import React from "react";
import { Link } from "react-router-dom";
import "./App.css";

function Navbar() {
  return (
    <div className="Navbar-main-cntainer">
      <nav className="navbar">
        <img
          src="main-logo.png"
          alt="Logo"
          className="navbar-logo"
        />

        <ul className="navbar-menu">
          <li><Link to="/"><b>Home</b></Link></li>
          <li><Link to="/farm"><b>Farm</b></Link></li>
          <li><Link to="/production"><b>Production</b></Link></li>
          <li><Link to="/about"><b>About</b></Link></li>
          <li><Link to="/contact"><b>Contact Us</b></Link></li>
        </ul>
      </nav>
    </div>
  );
}

export default Navbar;
